import $ = require('jquery');
import Status from './Status';

export interface BackendData {
    'status-code': string;
    'crawling-url'?: string;
    'crawlable-urls'?: Array<BackendCrawlableUrl>;
    'details'?: Array<any>;
    'updated-at'?: number;
}
export interface BackendCrawlableUrl {
    url: string;
    type: string;
}

export class ImportType {
    static WSC = 'WSC';
    static WSB = 'WSB';
}

export default class Backend {

    static startExternalImport(websiteId: string): Promise<boolean> {
        return this.setExternalImportData(websiteId, {
                'status-code': Status.RUNNING
            }
        );
    }

    static skipExternalImport(websiteId: string): Promise<boolean> {
        return this.setExternalImportData(websiteId, {
                'status-code': Status.SKIPPED
            }
        );
    }

    static skipDisclaimer(websiteId: string): Promise<boolean> {
        return this.setExternalImportData(websiteId, {
                'status-code': Status.SKIPPED_DISCLAIMER
            }
        );
    }

    static getExternalImportData(websiteId: string): Promise<BackendData> {
        return new Promise(function(resolve, reject) {
            $.ajax({
                url: '/rest/websites/' + websiteId + '/external-import',
                headers: {"Accept": "application/vnd.oneandone.diy.website.external-import+json"},
                type: 'GET',
                success: (data: BackendData) => {
                    resolve(data);
                },
                error: () => {
                    reject('Request External Import GET Failed');
                }
            });
        });
    }

    static setExternalImportData(websiteId: string, data: any): Promise<boolean> {
        return new Promise(function(resolve, reject) {
            $.ajax({
                url: '/rest/websites/' + websiteId + '/external-import',
                contentType: "application/vnd.oneandone.diy.website.external-import+json",
                type: 'POST',
                data: JSON.stringify(data),
                success: () => {
                    resolve(true);
                },
                error: () => {
                    reject('Request External Import POST Failed');
                }
            });
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/Backend.ts
 **/